<template>
	<div>
		<transition name="home-fade">
			<component :is="view" :process="process" :trans-duration="transDuration" :loading-process="loadingProcess"></component>
		</transition>
	</div>
</template>

<script>
import mainPage from "../pages/home/main.vue";
import loadingPage from "../components/loading.vue";

export default {
	name: "home",

	components: {
		"main-page": mainPage,
		"loading-page": loadingPage,
	},
	data: () => ({
		view: "loading-page",
		process: 0,
		transDuration: 3,
		loadingProcess: true,

		preloadImg: [
			require("../assets/images/logo_loading.png"),
			require("../assets/images/logo.png"),
			require("../assets/images/logo_small.png"),
			// header
			require("../assets/images/home/header/character_off.png"),
			require("../assets/images/home/header/character_on.png"),
			require("../assets/images/home/header/gallery_off.png"),
			require("../assets/images/home/header/gallery_on.png"),
			require("../assets/images/home/header/news_off.png"),
			require("../assets/images/home/header/news_on.png"),
			require("../assets/images/home/header/spec_off.png"),
			require("../assets/images/home/header/spec_on.png"),
			require("../assets/images/home/header/system_off.png"),
			require("../assets/images/home/header/system_on.png"),
			require("../assets/images/home/header/world_off.png"),
			require("../assets/images/home/header/world_on.png"),
            // page01
            require("../assets/images/home/page01/top.png"),
			require("../assets/images/home/page01/top_release.png"),
            require("../assets/images/home/page01/slogan.png"),
            require("../assets/images/home/page01/dl_button.png"),
            // page02
            require("../assets/images/home/page02/bg.png")
		],
		preloadVideo: [
			{
                // url: "/video/logo_anime.mp4",
                url: require("../assets/video/logo_anime.mp4"),
				name: "loading"
            },
            {
                url: require("../assets/video/top.mp4"),
                name: "TOP"
            }
		],
		// getVideoStatus: true,		// 视频请求是否成功
	}),
	created() {
		// 
		if(this.$route.query['news-id']) {
			this.view = "main-page"
		}
        
        // 预加载图片
        this.$utils.perLoadImg(this.preloadImg, 0.7, (percent) => {
            this.process += percent;
        })
        // 预加载视频
        this.$utils.perloadVideo(this.preloadVideo, 0.3, (percent) => {
            this.process += percent;
        })
        
		// 请求视频地址
		/* this.axios.get(`${process.env.VUE_APP_HOST}/video`).then(v => {
			if(v.data.code == 20000) {
				let videolist =  v.data.data
				let videoobj = {}		// 需要添加预加载的视频对象

				for(let key in videolist) {
					if(key == 'TOP') {
						videoobj.name = key;
						videoobj.url = videolist[key].link;
						// 插入需要预加载视频
						this.preloadVideo.push(videoobj)
					}
					// 插入需要预加载图片
					this.preloadImg.push(videolist[key].link1)
					// 保存视频背景图片地址
					this.$store.commit("SET_VIDEO_BG", {
						name: key,
						imgurl: videolist[key].link1
					})
					// 保存视频地址
					this.$store.commit("SET_BLOBURL", {
						name: key,
						bloburl: videolist[key].link
					})
				}
				// 预加载图片
				this.$utils.perLoadImg(this.preloadImg, 0.7, (percent) => {
					this.process += percent;
				})
				// 预加载视频
				this.$utils.perloadVideo(this.preloadVideo, 0.3, (percent) => {
					this.process += percent;
				})
			} else {
				this.getVideoStatus = false
			}
		}).catch(e => {
			console.log(e)
			this.getVideoStatus = false
		}) */
	},
	mounted() {
	},
	watch: {
		process(val) {
			if(val >= 99) {
				this.loaded()
			}
		},
		/* getVideoStatus(val) {
			if(!val) {		// 视频请求失败
				// 预加载图片
				this.$utils.perLoadImg(this.preloadImg, 1, (percent) => {
					this.process += percent;
				})
			}
		} */
	},
	computed: {

	},
	methods: {
		loaded() {
			setTimeout(() => {
				this.loadingProcess = false
				setTimeout(() => {
					this.view = "main-page"
				}, 2000)
				
			}, this.transDuration * 1000)
		}
	},
};
</script>

<style lang="scss" scoped>
.home-fade-enter-active, .home-fade-leave-active {
	transition: all 1s;
}
.home-fade-enter, .home-fade-leave-to {
	opacity: 0;
}
</style>
